export function isValidIpAddress(value: string) {
  return checkIsValidIpAddressFormat(value) && checkHasValidLength(value);
}

// entered value must be 4 numbers between 0 and 255, separated by .
function checkIsValidIpAddressFormat(value: string) {
  return new RegExp(/^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/).test(
    value,
  );
}

function checkHasValidLength(value: string) {
  return value?.length > 0;
}
